import {
  Autocomplete,
  Popper,
  TextField,
  autocompleteClasses,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/styles";
import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const StyledPopper = styled(Popper)(({ theme }) => ({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontSize: '11px',
    '& li': {
      padding: '3px 8px',
    },
  },
}));

const FactoryVendorEditor = forwardRef((props, ref) => {
  const [vendor, setVendor] = useState(props.value);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [vendId, setVendId] = useState(props.data.vendorNum);
  const refInput = useRef();
  const theme = useTheme();

  const getVendorList = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}?size=100`;
    
    try {
      const vendors = await OAuthService.getList(url);
      const result = vendors?.data?._embedded?.factoryVendors.map((value) => {
        return { label: value.name, value: value.name, id: value.id };
      });
      setVendorOptions(result);
    } catch (error) {}
  };
  useEffect(() => {
    getVendorList();
  }, []);

  const handleVendorChange = (e, data) => {
    data.value && setVendor(data.value);
    data.id && setVendId(data.id);
    const rowData = props.node;
    data.value && rowData.setDataValue("factoryVendor", data.value);
    data.id && rowData.setDataValue("vendorId", data.id);
  };

  useEffect(() => {
    // get ref from React component
    window.setTimeout(() => {
      const eInput = refInput.current;
      eInput.focus();
    });
  }, []);
  
  useImperativeHandle(ref, () => {
    return {
      getValue() {
        const rowNode = props.node;
        rowNode.setDataValue("vendorId", vendId);
        rowNode.setDataValue("factoryVendor", vendor);
        return vendor;
      },
      getVendorID() {
        return vendId;
      },
      focusIn() {
        var eInput = refInput.current;
        eInput.focus();
        eInput.select();
      },
    };
  });

  return (
    <Autocomplete
      options={vendorOptions}
      value={
        vendId && vendorOptions.length > 0
          ? vendorOptions.filter((obj) => obj.id === vendId)
            ? vendorOptions.filter((obj) => obj.id === vendId)[0]
            : ""
          : ""
      }
      onChange={handleVendorChange}
      onInputChange={handleVendorChange}
      disableClearable
      PopperComponent={StyledPopper}
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={"Select "}
          inputRef={refInput}
          className="customDatePickerDiscount"
         sx={{
            border: !vendor ? "1px solid red" : "none",
            fontSize: "smaller",
            backgroundColor: theme.palette.background.paper,
            "& .MuiInputBase-input": {
              color: theme.palette.text.primary,
            },
          }}
        />
      )}
    />
  );
});

export default FactoryVendorEditor;
